import React from 'react';

import { Droppable } from 'react-beautiful-dnd';

export default function DroppableTbody({ children, id, ...restProps }) {
    return (
        <Droppable droppableId={id}>
            {(provided) => (
                <tbody
                    {...restProps}
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                >
                    {children}
                    {provided.placeholder}
                </tbody>
            )}
        </Droppable>
    );
}
